// Module
var code = " <gh-page layout=\"catalog\"> <gh-page-content> <gh-page-error icon=\"gh:help-outline\" title=\"{{'lbl_page_not_implemented_text' | translate}}\"></gh-page-error> </gh-page-content> </gh-page>";
// Exports
module.exports = code;